<template>
    <div class="rounded-xl border border-gray-200 bg-white p-5">
        <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
            <h2 class="font-semibold text-gray-900">
                {{ t("vue.kiosk_da_chart_title") }}
            </h2>
            <div class="flex items-center gap-2">
                <!-- View toggle: Day / 14 days -->
                <div class="flex gap-1 rounded-lg bg-gray-100 p-0.5">
                    <button
                        type="button"
                        class="rounded-md px-2.5 py-1 text-xs font-medium transition-all"
                        :class="
                            activeChartView === 'day'
                                ? 'bg-white text-gray-900 shadow-sm'
                                : 'text-gray-500 hover:text-gray-700'
                        "
                        @click="activeChartView = 'day'"
                    >
                        {{ t("vue.kiosk_da_chart_view_day") }}
                    </button>
                    <button
                        type="button"
                        class="rounded-md px-2.5 py-1 text-xs font-medium transition-all"
                        :class="
                            activeChartView === 'trend'
                                ? 'bg-white text-gray-900 shadow-sm'
                                : 'text-gray-500 hover:text-gray-700'
                        "
                        @click="activeChartView = 'trend'"
                    >
                        {{ t("vue.kiosk_da_chart_view_trend") }}
                    </button>
                </div>
                <!-- Series tabs -->
                <div class="flex gap-1">
                    <button
                        v-for="ct in chartTabs"
                        :key="ct.key"
                        type="button"
                        class="rounded-md px-3 py-1 text-sm font-medium transition-all"
                        :class="
                            activeChartTab === ct.key
                                ? 'bg-indigo-600 text-white shadow-sm'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        "
                        @click="activeChartTab = ct.key"
                    >
                        {{ ct.label }}
                    </button>
                </div>
            </div>
        </div>
        <ActivityTrendChart
            :key="`${activeChartTab}-${activeChartView}`"
            :chart-data="trendData"
            :active-tab="activeChartTab"
            :active-view="activeChartView"
            :selected-date="date"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useTranslations } from "@/composables/useTranslations";
import ActivityTrendChart from "./ActivityTrendChart.vue";
import type { ChartView } from "./ActivityTrendChart.vue";
import type { ChartTab, IChartTabDef, ITrendDataItem } from "../types";

const { t } = useTranslations();

defineProps<{
    trendData: ITrendDataItem[];
    date: string;
}>();

const activeChartTab = ref<ChartTab>("activity");
const activeChartView = ref<ChartView>("trend");

const chartTabs = computed((): IChartTabDef[] => [
    { key: "activity", label: t("vue.kiosk_da_chart_tab_activity") },
    { key: "users", label: t("vue.kiosk_da_chart_tab_users") },
    { key: "plans", label: t("vue.kiosk_da_chart_tab_plans") },
]);
</script>
